import { render, staticRenderFns } from "./EditableText.vue?vue&type=template&id=41895418&scoped=true&"
import script from "./EditableText.vue?vue&type=script&lang=ts&"
export * from "./EditableText.vue?vue&type=script&lang=ts&"
import style0 from "./EditableText.vue?vue&type=style&index=0&id=41895418&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41895418",
  null
  
)

export default component.exports